import { Avatar } from "shared/components/atoms/Avatar";
import { BackButton } from "shared/components/atoms/BackButton";
import { Button } from "shared/components/atoms/Button";
import { List } from "shared/components/molecules/List";
import { ReviewCard } from "shared/components/molecules/ReviewCard";
import { StarRating } from "shared/components/molecules/StarRating";
import { Loading } from "shared/components/templates/Loading";
import { FortuneTeller, Review } from "shared/types";

interface Props {
  title: string;
  fortuneTeller?: FortuneTeller;
  pages: Review[][];
  isLoading?: boolean;
  hasNextPage: boolean;
  onLoadMore: () => void;
}

/**
 *
 * @param title [string]
 * @param fortuneTeller [FortuneTeller] optional
 * @param pages [Review[][]]
 * @param isLoading [boolean] optional
 * @param hasNextPage [boolean]
 * @param onLoadMore [() => void]
 * @returns
 */
export const ReviewList = ({
  title,
  fortuneTeller,
  pages,
  isLoading,
  hasNextPage,
  onLoadMore,
}: Props) => {
  return (
    <>
      <Loading loading={isLoading} />
      <BackButton text="戻る" />
      <div tw="p-5 flex flex-col items-center">
        <Avatar
          tw="mb-3"
          src={fortuneTeller?.thumbnailUrl}
          fallback={fortuneTeller?.imageUrl}
          size={84}
        />
        <h2 tw="font-base text-base tracking-[-0.49px]">{title}</h2>
        <div tw="flex justify-center mt-2">
          <StarRating rate={fortuneTeller?.averageScore} size="large" />
          <span tw="font-base font-light text-xs leading-3 tracking-[.3px] text-secondary ml-1">
            ({fortuneTeller?.reviewCounts})
          </span>
        </div>
        <List
          data={pages}
          renderItem={(reviews) => (
            <List
              data={reviews}
              renderItem={(review) => <ReviewCard review={review} tw="mt-6" />}
              bottomBorder={false}
            />
          )}
          bottomBorder={false}
        />
        {hasNextPage && (
          <Button tw="w-[219px] h-12 bg-gray mt-6" onClick={onLoadMore}>
            <span tw="font-base font-normal text-sm leading-[14px] tracking-[.41px] text-secondary">
              ▼ もっと見る
            </span>
          </Button>
        )}
      </div>
    </>
  );
};
